module.exports = __webpack_public_path__ + "static/media/promo-v2-5.3d2f3f0d.jpeg";